export default __webpack_public_path__ + "static/media/appbutton.5f0b6eab.png";